import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useStateValue } from '../../StateProvider';

function Example({ setSortedData}) {
  const [{ admin_search }, dispatch] = useStateValue()
  const [show, setShow] = useState(false);
  const [price, setPrice] = useState('')
  const [stock, setStock] = useState('')
  const [active,setActive]=useState(true)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [priceComparison, setPriceComparison] = useState('');
  const [priceValue, setPriceValue] = useState('');

  useEffect(() => {
    return () => {
      setPrice('')
      setStock('')
      localStorage.removeItem('priceFilter')
      localStorage.removeItem('stockFilter')
      setPriceComparison('')
      setPriceValue('');
    };
  }, [])
  useEffect(() => {
    if (price === '') {
      const storedFilter = localStorage.getItem('priceFilter');
      if (storedFilter) {
        setPrice(storedFilter)
      }
    }
    if (stock === '') {
      const storedFilter = localStorage.getItem('stockFilter');
      if (storedFilter) {
        setStock(storedFilter)
      }
    }
  }, [price, stock])
  const clearFilter = () => {
    setPrice('')
    setStock('')
    setPriceComparison('');
    setPriceValue(''); 
    setSortedData(admin_search)
    dispatch({
      type: "ADMIN_SEARCH_PRODUCTS",
      payload: admin_search
    })
    localStorage.removeItem('priceFilter');
    localStorage.removeItem('stockFilter');
    localStorage.removeItem('priceComparison');
    localStorage.removeItem('priceValue');
  }
  const handleFilter = (e) => {
    e.preventDefault()
    let sortedData = [...admin_search]
    if(active){
      sortedData=sortedData.filter((product)=>product.active===true)
    }
    if(!active){
      sortedData=sortedData.filter((product)=>product.active===false)
    }
    if (priceComparison === 'greater than' && priceValue) {
      sortedData = sortedData.filter((product) => product.price > parseFloat(priceValue));
    }
    if (priceComparison === 'less than' && priceValue) {
      sortedData = sortedData.filter((product) => product.price < parseFloat(priceValue));
    }
    if (price === "High to low") {
      sortedData = sortedData.sort((a, b) => (b.price) - (a.price))
    }
    if (price === "Low to high") {
      sortedData.sort((a, b) => (a.price) - (b.price))
    }
    if (stock === "High to low") {
      sortedData = sortedData.sort((a, b) => (b.stock) - (a.stock))
    }
    if (stock === "Low to high") {
      sortedData.sort((a, b) => (a.stock) - (b.stock))
    }
    setSortedData(sortedData)
    localStorage.setItem('priceFilter', price);
    localStorage.setItem('stockFilter', stock);
    localStorage.setItem('priceComparison', priceComparison);
    localStorage.setItem('priceValue', priceValue);
    setShow(false)
  }

  return (
    <>
      <FilterAltIcon fontSize='large' onClick={handleShow} />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <form onSubmit={handleFilter}>
              <label className='font-weight-bold' htmlFor="price">Price</label><br></br>
              <input checked={price === 'High to low'} className='mr-2' type="radio" id="price-high-to-low" name="price" value="High to low" onChange={(e) => setPrice(e.target.value)} />
              <label htmlFor="price-high-to-low">High to low</label><br></br>
              <input checked={price === 'Low to high'} className='mr-2' type="radio" id="price-low-to-high" name="price" value="Low to high" onChange={(e) => setPrice(e.target.value)} />
              <label htmlFor="price-low-to-high">Low to high</label><br></br>

              <label className='font-weight-bold' htmlFor="stock">Stock</label><br></br>
              <input checked={stock === 'High to low'} className='mr-2' type="radio" id="stock-high-to-low" name="stock" value="High to low" onChange={(e) => setStock(e.target.value)} />
              <label htmlFor="stock-high-to-low">High to low</label><br></br>
              <input checked={stock === 'Low to high'} className='mr-2' type="radio" id="stock-low-to-high" name="stock" value="Low to high" onChange={(e) => setStock(e.target.value)} />
              <label htmlFor="stock-low-to-high">Low to high</label><br></br>

              <div>
              <label className='font-weight-bold' htmlFor="status">Status</label><br></br>
              <input checked={active} className='mr-2' type="radio" id="status" name="status" value="Active" onChange={(e) => setActive(true)} />
              <label htmlFor="active">Active</label><br></br>
              <input checked={!active} className='mr-2' type="radio" id="inactive" name="status" value="Inactive" onChange={(e) => setActive(false)} />
              <label htmlFor="inactive">Inactive</label><br></br>
              </div>
              <label className="font-weight-bold" htmlFor="price-comparison">
                Price Comparison
              </label>
              <br />
              <input
                className="mr-2"
                type="radio"
                id="greater-than"
                name="price-comparison"
                value="greater than"
                checked={priceComparison === 'greater than'} 
                onChange={(e) => setPriceComparison(e.target.value)}
              />
              <label htmlFor="greater-than">Greater than</label>
              <br />
              <input
                className="mr-2"
                type="radio"
                id="less-than"
                name="price-comparison"
                value="less than"
                checked={priceComparison === 'less than'}
                onChange={(e) => setPriceComparison(e.target.value)}
              />
              <label htmlFor="less-than">Less than</label>
              <br />
              {/* Price Value */}
              {priceComparison && (
                <div>
                  <label htmlFor="price-value">Enter Price Value</label>
                  <br />
                  <input
                    type="number"
                    id="price-value"
                    value={priceValue}
                    onChange={(e) => setPriceValue(e.target.value)}
                    placeholder="Enter a price"
                  />
                </div>
              )}

            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={clearFilter}>Clear</Button>
          <Button variant="success" onClick={handleFilter}>Apply</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Example;